import React, { useState, useRef, useEffect } from 'react';


import combineStyles from 'components/Templates/general/combineStyles';
import selectVenueById from 'helpers/selectVenueById';

import injectComponent from 'helpers/injectComponent';

import cloneDeep from 'helpers/cloneDeep';

import selectLinkedSection from 'helpers/selectLinkedSection';

export default function RendererComponent(props) {

  const {
    section,
    templateSchema,
    language = 'en',
    pageSlug,
    secondSlug,
    chapterSlug,
    params,
    windowWidth,
    currentPage,
    thisSectionData,
    indexSection
  } = props;

  const {
    pages,
    agenda,
    presentations,
    navigations,
    streams,
    speakers,
    companies,
    venues,
    forms,
    savedSections,
    organizationId,
    templateId,
    title,
    dateFrom,
    dateTo,
    defaultVenue,
    logo,
    tickets,
    subscriptions,
    calendars,
    customStyles,
    faviconImage,
    dateToWithTime,
    dateFromWithTime,
    presentationTags,
    eventTags
  } = templateSchema;

  const ref = useRef(null);

  const [sectionRender, setSectionRender] = useState('');
  const [thisSectionSelect, setThisSectionSelect] = useState(selectLinkedSection(savedSections, thisSectionData.sectionIdLinked ? thisSectionData.sectionIdLinked : thisSectionData.sectionId, thisSectionData));
  const getSectionData = thisSectionSelect.section ? thisSectionSelect.section : thisSectionSelect;
  const [isIntersecting, setIsIntersecting] = useState(indexSection < 3 || getSectionData.type === 'navigation');


  useEffect(() => {
    const fetchComponent = async () => {

      const defaultValues = {
        title: title,
        dateFrom: dateFrom,
        dateTo: dateTo,
        dateToWithTime: dateToWithTime,
        dateFromWithTime: dateFromWithTime,
        timezone: templateSchema.timezone,
        twitterAccount: templateSchema.twitterAccount,
        facebookAccount: templateSchema.facebookAccount,
        linkedinAccount: templateSchema.linkedinAccount,
        instagramAccount: templateSchema.instagramAccount,
        slackAccount: templateSchema.slackAccount,
        city: templateSchema.city,
        isOnline: templateSchema.isOnline,
      };

      const agendaData = {
        presentations: presentations,
        agenda: agenda,
      }



      const selectVenue = defaultVenue ? selectVenueById(venues, defaultVenue) : '';
      if (selectVenue) defaultValues.defaultVenueData = selectVenue;
    
      if (getSectionData && (getSectionData.type === 'agenda' || getSectionData.type === 'agendaStacked')) getSectionData.availableTags = presentationTags;
      if (getSectionData && getSectionData.type === 'calendar') getSectionData.availableTags = eventTags;
      
      const thisComponent = await injectComponent(getSectionData.type, getSectionData.componentName, 'component');

      const setStyling = async function fnSetStyling() {

        try {

          const awaitRequire = await injectComponent(getSectionData.type, thisSectionSelect.componentName, 'style');

          if (!awaitRequire || !awaitRequire.default) return;

          let requireStyling = cloneDeep(awaitRequire.default);
      
          async function customStylesSelect()  {
            try {
              const awaitCustom = await injectComponent(getSectionData.type, getSectionData.componentName, 'default');
              if (!awaitCustom || !awaitCustom.default) return customStyles;
              return {
                ...awaitCustom.default,
                ...customStyles
              };
            } catch(error) {
              console.log(error);
            }
          };

          const getCustomStyles = await customStylesSelect();

          requireStyling = combineStyles(requireStyling, getSectionData.styling, getCustomStyles);

          return requireStyling;
        } catch(e) {
          console.log(e);
        }

      }();

      const commonProps = {
        language: language,
        styling: await setStyling,
        pages: pages,
        timezone: templateSchema.timezone,
        baseUrlTamplate: pageSlug === 'location' && secondSlug ? '/location/'+secondSlug : chapterSlug ? '/location/'+chapterSlug : '',
        logo: logo,
        params: params,
        savedSections: savedSections,
        windowWidth: windowWidth,
        faviconImage: faviconImage,
        viewRef: '#PublicViewEventWrapper-id',
      };

      const commonData = {
        componentPayload: getSectionData,
        styling:  setStyling,
        pageIdLinked: section.pageIdLinked,
        sectionIdLinked: section.sectionIdLinked,
        sectionId: section.sectionId,
        organizationId: organizationId,
        templateId: templateId,
        pageId: currentPage.pageId,
        customStyles: customStyles,
        renderSync: getSectionData.type === 'navigation'
      };

      if (thisComponent) {

        const {
          type
        } = thisSectionSelect;


        if (type === 'insights') {
          if (speakers && speakers.length) defaultValues.speakerLength = speakers.length;
          if (companies && companies.length) defaultValues.companiesLength = companies.length;
          if (agendaData && agendaData.agenda && agendaData.agenda.length) defaultValues.daysLength = agendaData.agenda.length;
          defaultValues.attendeesLength = speakers && speakers.length ? speakers.length : 0;


          defaultValues.attendeesLength = speakers && speakers.length ? speakers.length : 0;

          if (tickets && tickets.length) {
            for (let index = 0; index < tickets.length; index++) {
              const element = tickets[index];
              if (element.numberSold) defaultValues.attendeesLength = defaultValues.attendeesLength + element.numberSold;
            }
          }
        }

        setSectionRender(
          {
            component: thisComponent,
            commonProps: commonProps,
            commonData: commonData,
            agendaData: type === 'agenda' || type.toLowerCase() === 'miniagenda' || type === 'agendaStacked' || type === 'speaker' ? agendaData : null,
            presentations: type === 'speaker' ? presentations : null,
            tickets: type === 'tickets' ? getSectionData.tickets : null,
            ticketsData: type === 'tickets' || type === 'workshop' ? tickets : null,
            presentationsData: type === 'workshop' ? presentations : null,
            subscriptions: type === 'subscriptions' ? getSectionData.subscriptions : null,
            subscriptionsData: type === 'subscriptions' ? subscriptions : null,
            navigationId: type === 'navigation' ? getSectionData.navigationId : null,
            navigations: type === 'navigation' ? navigations : null,
            speakers: type === 'speakers' || type === 'agenda' || type.toLowerCase() === 'miniagenda' || type === 'speaker' || type === 'workshop'|| type === 'agendaStacked' ? speakers : null,
            companies: type === 'partners' || type === 'speakers' || type === 'agenda' || type.toLowerCase() === 'miniagenda'|| type === 'agendaStacked' ? companies : null,
            forms: type === 'form' ? forms : null,
            calendars: type === 'calendar' ? calendars : null,
            streams: type === 'stream' ? streams : null,
            venues: type === 'venue' ? venues : null,
            defaultVenue: type === 'venue' ? defaultVenue : null,
            defaultValues: defaultValues,
            viewRef: '#PublicViewEventWrapper-id',
          }
        );
          
      }

    }
    fetchComponent();

  }, [windowWidth])


  useEffect(() => {
    if (!isIntersecting) {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          setIsIntersecting(entry.isIntersecting);
          observer.disconnect();
        }
      }, {
        rootMargin: '500px'
      });
      observer.observe(ref.current);
      return () => observer.disconnect();
    }
  }, []);

  const ThisComponent = sectionRender && sectionRender?.component && window?.injectCache[sectionRender.component] && window.injectCache[sectionRender.component] ? window.injectCache[sectionRender.component] : '';
  
  return isIntersecting && sectionRender?.component && ThisComponent?.default ? (
    <ThisComponent.default
      {...sectionRender}
    />
  ) :   (
    <div
      ref={ref}
      style={
        {
          height: indexSection < 1 ? '10rem' : '66rem'
        }
      }
    >
    </div>
  );

}